import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormError from './FormError';
import InputField from './InputField';
import SelectField from './SelectField';
import CheckboxField from './CheckboxField';

const accountTypesOptions = [
  ['checking', 'checking'],
  ['savings', 'savings'],
  ['businessChecking', 'businessChecking'],
];

const echeckTypesOptions = [
  ['WEB', 'WEB'],
  ['PPD', 'PPD'],
  ['CCD', 'CCD'],
];

let UpdatePaymentProfileECheckForm = ({
  paymentMethods = [],
  isDefault,
  handleSubmit,
  error,
  successMsg,
}) => {
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Field
          component={SelectField}
          name="card_id"
          label="Payment Method"
          empty="Select payment method"
          options={paymentMethods.map((method) => [
            method.id,
            method.account_number,
          ])}
        />
        <Field
          component={SelectField}
          name="account_type"
          label="Account Type"
          empty="Choose an Account Type"
          options={accountTypesOptions}
        />
        <Field
          component={InputField}
          name="routing_number"
          label="*Routing Number"
        />
        <Field
          component={InputField}
          name="account_number"
          label="*Account Number"
        />
        <Field
          component={InputField}
          name="name_on_account"
          label="*Name On Account"
        />
        <Field
          component={SelectField}
          name="echeck_type"
          label="ECheck Type"
          empty="Choose an ECheck Type"
          options={echeckTypesOptions}
        />
        <Field component={InputField} name="bank_name" label="Bank Name" />
        {!isDefault && (
          <Field
            component={CheckboxField}
            name="is_default"
            label="Is default"
          />
        )}
        {error && <FormError error={error} />}
        {successMsg && <p className="text-success">{successMsg}</p>}
        <button className="btn btn-primary">Update payment method</button>
      </form>
    </div>
  );
};

const validate = (values) => {
  let errors = {};

  const requiredFields = [
    'routing_number',
    'account_number',
    'name_on_account',
  ];
  requiredFields.forEach((key) => {
    if (!values[key]) {
      errors[key] = 'Required';
    }
  });

  if (values.zip_code && values.zip_code.length !== 5) {
    errors.zip_code = 'Zip Code must be exactly 5 digits';
  }

  const addressFields = {
    first_name: values.first_name,
    last_name: values.last_name,
    address: values.address,
    city: values.city,
    state: values.state,
    zip_code: values.zip_code,
  };

  const isAddressFieldPopulated = Object.values(addressFields).filter(
    (field) => field,
  );
  if (isAddressFieldPopulated.length > 0) {
    Object.keys(addressFields).forEach((key) => {
      if (!addressFields[key]) {
        errors[key] = 'Required';
      }
    });
  }

  return errors;
};

UpdatePaymentProfileECheckForm = reduxForm({
  form: 'updatePaymentProfile',
  enableReinitialize: true,
  validate,
})(UpdatePaymentProfileECheckForm);

export default UpdatePaymentProfileECheckForm;
